import { BaseModel } from '../base-model';

export interface ISmartSuggest {
  FieldCategory?: string;
  FieldId?: number;
  FieldName?: string;
  IconUrl?: string;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  Reference?: string;
  SuggestNameEN?: string;
  SuggestNameFR?: string;
  SuggestNameNL?: string;
}
export class SmartSuggest extends BaseModel<ISmartSuggest> implements ISmartSuggest {
  FieldCategory: string;
  FieldId: number;
  FieldName: string;
  IconUrl: string;
  NameEN: string;
  NameFR: string;
  NameNL: string;
  Reference: string;
  SuggestNameEN: string;
  SuggestNameFR: string;
  SuggestNameNL: string;
  /**
   *
   */
  constructor(option: ISmartSuggest) {
    super(option);
  }
}